document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.accordion-item');

  items.forEach((item) => {
    const btn = item.querySelector('.accordion-title');
    const content = item.querySelector('.accordion-content');

    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');

      // すべて閉じたい場合は以下を有効化
      // items.forEach(i => {
      //   i.classList.remove('open');
      //   i.querySelector('.accordion-title').setAttribute('aria-expanded', 'false');
      //   i.querySelector('.accordion-content').style.maxHeight = null;
      // });

      // トグル動作
      if (isOpen) {
        item.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = null;
      } else {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});
